import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import styles from './quickLaunchFooter.scss'
import quickLaunchIcon from 'assets/components/npp/quick_launch_footer/npp_quick_launch_rocket.svg'

class QuickLaunchFooter extends PureComponent {
	render() {
		return (
			<div styleName="wrapper">
				<span styleName='icon'>
					<Isvg src={quickLaunchIcon} styleName='icon-svg' />
				</span>
				<p styleName="text">Quick Launch</p>
			</div>
		)
	}
}

export default CSSModules(QuickLaunchFooter, styles, { allowMultiple: true })
